import { ImageErrorType, ModerationErrorType, UserPersonaErrorType, } from "@next-platform/packages-ts-types";
import { getErrorType } from "../../utils/getErrorType";
import { useCallback } from "react";
import { useTranslation } from "../localization/hooks";
import { getModerationErrorMessage } from "./getModerationErrorMessage";
import { ModerationFlows } from "./types";
// eslint-disable-next-line max-lines-per-function -- exhaustive error-type × flow lookup table
const buildErrorMessagesMap = ({ messages, }) => ({
    // ModerationErrorType mappings
    [ModerationErrorType.SERVER_ERROR]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.SERVER_ERROR_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.SERVER_ERROR_UPDATE_CHATBOT,
        [ModerationFlows.CREATE_PERSONA]: messages.SERVER_ERROR_CREATE_PERSONA,
        [ModerationFlows.UPDATE_PERSONA]: messages.SERVER_ERROR_UPDATE_PERSONA,
        [ModerationFlows.UPDATE_USER]: messages.SERVER_ERROR_UPDATE_USER,
    },
    [ModerationErrorType.INVALID_REQUEST]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.INVALID_REQUEST_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.INVALID_REQUEST_UPDATE_CHATBOT,
    },
    [ModerationErrorType.INVALID_RESPONSE]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.INVALID_RESPONSE_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.INVALID_RESPONSE_UPDATE_CHATBOT,
    },
    [ModerationErrorType.AVATAR_WITH_SEXUAL_ACTIVITIES]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.AVATAR_WITH_SEXUAL_ACTIVITIES_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.AVATAR_WITH_SEXUAL_ACTIVITIES_UPDATE_CHATBOT,
    },
    [ModerationErrorType.AVATAR_TOO_EXPLICIT]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.AVATAR_TOO_EXPLICIT_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.AVATAR_TOO_EXPLICIT_UPDATE_CHATBOT,
        [ModerationFlows.CREATE_PERSONA]: messages.AVATAR_TOO_EXPLICIT_CREATE_PERSONA,
        [ModerationFlows.UPDATE_PERSONA]: messages.AVATAR_TOO_EXPLICIT_UPDATE_PERSONA,
        [ModerationFlows.UPDATE_USER]: messages.AVATAR_TOO_EXPLICIT_UPDATE_USER,
    },
    [ModerationErrorType.UNDERAGE_AVATAR_NOT_ALLOWED]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.UNDERAGE_AVATAR_NOT_ALLOWED_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.UNDERAGE_AVATAR_NOT_ALLOWED_UPDATE_CHATBOT,
        [ModerationFlows.CREATE_PERSONA]: messages.UNDERAGE_AVATAR_NOT_ALLOWED_CREATE_PERSONA,
        [ModerationFlows.UPDATE_PERSONA]: messages.UNDERAGE_AVATAR_NOT_ALLOWED_UPDATE_PERSONA,
        [ModerationFlows.UPDATE_USER]: messages.UNDERAGE_AVATAR_NOT_ALLOWED_UPDATE_USER,
    },
    [ModerationErrorType.BESTIALITY_TEXT]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.BESTIALITY_TEXT_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.BESTIALITY_TEXT_UPDATE_CHATBOT,
        [ModerationFlows.CREATE_PERSONA]: messages.BESTIALITY_TEXT_CREATE_PERSONA,
        [ModerationFlows.UPDATE_PERSONA]: messages.BESTIALITY_TEXT_UPDATE_PERSONA,
        [ModerationFlows.UPDATE_USER]: messages.BESTIALITY_TEXT_UPDATE_USER,
    },
    [ModerationErrorType.UNDERAGE_TEXT]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.UNDERAGE_TEXT_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.UNDERAGE_TEXT_UPDATE_CHATBOT,
    },
    [ModerationErrorType.NSFW_TEXT]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.NSFW_TEXT_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.NSFW_TEXT_UPDATE_CHATBOT,
    },
    [ModerationErrorType.IMAGE_MODERATION_ERROR]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.IMAGE_MODERATION_ERROR_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.IMAGE_MODERATION_ERROR_UPDATE_CHATBOT,
    },
    [ModerationErrorType.MODERATION_ERROR]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.MODERATION_ERROR_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.MODERATION_ERROR_UPDATE_CHATBOT,
    },
    [ModerationErrorType.COMMUNITY_GUIDELINES_VIOLATION]: {
        [ModerationFlows.CREATE_CHATBOT]: messages.COMMUNITY_GUIDELINES_VIOLATION_CREATE_CHATBOT,
        [ModerationFlows.UPDATE_CHATBOT]: messages.COMMUNITY_GUIDELINES_VIOLATION_UPDATE_CHATBOT,
        [ModerationFlows.CREATE_PERSONA]: messages.COMMUNITY_GUIDELINES_VIOLATION_CREATE_PERSONA,
        [ModerationFlows.UPDATE_PERSONA]: messages.COMMUNITY_GUIDELINES_VIOLATION_UPDATE_PERSONA,
        [ModerationFlows.UPDATE_USER]: messages.COMMUNITY_GUIDELINES_VIOLATION_UPDATE_USER,
    },
    // UserPersonaErrorType mappings
    [UserPersonaErrorType.UNDER_AGE_CONTENT_FOUND]: {
        [ModerationFlows.CREATE_PERSONA]: messages.UNDER_AGE_CONTENT_FOUND_CREATE_PERSONA,
        [ModerationFlows.UPDATE_PERSONA]: messages.UNDER_AGE_CONTENT_FOUND_UPDATE_PERSONA,
        [ModerationFlows.UPDATE_USER]: messages.UNDER_AGE_CONTENT_FOUND_UPDATE_USER,
    },
    [UserPersonaErrorType.NSFW_CONTENT_FOUND]: {
        [ModerationFlows.CREATE_PERSONA]: messages.NSFW_CONTENT_FOUND_CREATE_PERSONA,
        [ModerationFlows.UPDATE_PERSONA]: messages.NSFW_CONTENT_FOUND_UPDATE_PERSONA,
        [ModerationFlows.UPDATE_USER]: messages.NSFW_CONTENT_FOUND_UPDATE_USER,
    },
    // ImageErrorType mappings
    [ImageErrorType.UNDER_AGE_CONTENT_NOT_ALLOWED]: {
        [ModerationFlows.GENERATE_CONVERSATION_IMAGE]: messages.UNDER_AGE_CONTENT_NOT_ALLOWED_GENERATE_CONVERSATION_IMAGE,
        [ModerationFlows.GENERATE_IMAGE]: messages.UNDER_AGE_CONTENT_NOT_ALLOWED_GENERATE_IMAGE,
        [ModerationFlows.UPLOAD_USER_IMAGE]: messages.UNDER_AGE_CONTENT_NOT_ALLOWED_UPLOAD_USER_IMAGE,
    },
    [ImageErrorType.NSFW_CONTENT_NOT_ALLOWED]: {
        [ModerationFlows.GENERATE_CONVERSATION_IMAGE]: messages.NSFW_CONTENT_NOT_ALLOWED_GENERATE_CONVERSATION_IMAGE,
        [ModerationFlows.GENERATE_IMAGE]: messages.NSFW_CONTENT_NOT_ALLOWED_GENERATE_IMAGE,
        [ModerationFlows.UPLOAD_USER_IMAGE]: messages.NSFW_CONTENT_NOT_ALLOWED_UPLOAD_USER_IMAGE,
    },
    [ImageErrorType.NSFW_PUBLIC_FIGURE_NOT_ALLOWED]: {
        [ModerationFlows.GENERATE_IMAGE]: messages.NSFW_PUBLIC_FIGURE_NOT_ALLOWED_GENERATE_IMAGE,
    },
});
export function useModerationErrors() {
    const { t } = useTranslation();
    const moderationMessages = getModerationErrorMessage(t);
    const errorMessagesMap = buildErrorMessagesMap({
        messages: moderationMessages,
    });
    const getMessage = useCallback(({ errorCode, errorContext, skipDefaultMessage, }) => {
        const { flow } = errorContext || {};
        const errorType = getErrorType(errorCode, [
            ModerationErrorType,
            UserPersonaErrorType,
            ImageErrorType,
        ]);
        const flowErrorMessage = errorType
            ? errorMessagesMap[errorType]?.[flow]
            : undefined;
        if (flowErrorMessage) {
            return flowErrorMessage;
        }
        if (skipDefaultMessage)
            return "";
        return t("error:fallbackError");
    }, [errorMessagesMap, t]);
    return {
        getMessage,
    };
}
